import React from "react";
import { MainContainer } from "../../assets/styles/theme/styles";

// import ContactHome from "./components/ContactHome";
// import IMAGES from "../../utils/Images";
// import { HeroContainer, MainContainer } from "../assets/styles/theme/styles";

 

  export default function PrivacyPolicy() {
    return (
      <MainContainer>
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.7",
          color: "#333",
          maxWidth: "90%",
          margin: "0 auto",
          padding: "30px",
          backgroundColor: "#fff",
          borderRadius: "12px",
          // boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "10px" }}>
          Privacy Policy
        </h1>
        <p style={{ fontSize: "14px", marginBottom: "20px" }}>
          <strong>Effective Date:</strong> 1st April 2025
        </p>
  
        <p>
          This Privacy Policy describes how Tubelight Communications ("TCL," "we,"
          "us," or "our") collects, uses, processes, and protects the personal
          data of our customers and their end-users ("you" or "your") in
          connection with the use of our website www.tubelightcommunications.com ;
          www.1iNbox.ai ; and services, including our messaging, voice, contact
          center software, and other communication solutions (collectively, the
          "Services").
        </p>
  
        <p>
          By accessing or using our Services, you consent to the collection, use,
          and disclosure of your personal data as described in this Privacy
          Policy.
        </p>
  
        {/* Section 1 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          1. Information We Collect
        </h2>
        <p>
          We collect information to provide and improve our Services. The type of
          information we collect depends on your interaction with us:
        </p>
  
        <h3 style={{ fontSize: "18px", marginTop: "15px" }}>
          A. Information from Our Customers
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <strong>Account Information:</strong> Your name, company name, email
            address, physical address, and phone number.
          </li>
          <li>
            <strong>Payment Information:</strong> Billing details, credit card
            information, bank account information, and billing address.
          </li>
          <li>
            <strong>Business Information:</strong> Information you provide about
            your business, such as industry, company size, and specific use cases
            for our Services.
          </li>
          <li>
            <strong>Communications Data:</strong> Records of your communications
            with our customer support and sales teams.
          </li>
        </ul>
  
        <h3 style={{ fontSize: "18px", marginTop: "15px" }}>
          B. Information We Process on Behalf of Our Customers (End-User Data)
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <strong>Communication Content:</strong> Text messages (SMS), MMS, and
            voice calls. We process this data as necessary to provide the Services
            but do not monitor or control the content.
          </li>
          <li>
            <strong>Metadata:</strong> Phone numbers, timestamp, duration of
            calls, and delivery status.
          </li>
          <li>
            <strong>Contact Information:</strong> Phone numbers or other details
            you upload.
          </li>
          <li>
            <strong>Technical Information:</strong> IP addresses, device
            identifiers, and operating system info.
          </li>
        </ul>
  
        <h3 style={{ fontSize: "18px", marginTop: "15px" }}>
          C. Information from Your Use of Our Website and Services
        </h3>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <strong>Log Data:</strong> IP address, browser type, device info,
            visited pages, and timestamps.
          </li>
          <li>
            <strong>Cookies:</strong> We use cookies to track usage, remember
            preferences, and provide personalization.
          </li>
          <li>
            <strong>Analytics:</strong> We use third-party services to analyze how
            our Services are used.
          </li>
        </ul>
  
        {/* Section 2 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          2. How We Use the Information
        </h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>To provide and operate the Services.</li>
          <li>To improve functionality and performance.</li>
          <li>For security and fraud prevention.</li>
          <li>For service-related communication and support.</li>
          <li>To comply with laws and regulations.</li>
          <li>For billing and payments.</li>
        </ul>
  
        {/* Section 3 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          3. How We Share the Information
        </h2>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            <strong>Third-Party Service Providers:</strong> Telecom carriers,
            cloud hosting, and payment processors.
          </li>
          <li>
            <strong>Legal Authorities:</strong> When required to comply with law.
          </li>
          <li>
            <strong>Affiliates & Subsidiaries:</strong> For internal business
            purposes.
          </li>
          <li>
            <strong>Business Transfers:</strong> In case of mergers or
            acquisitions.
          </li>
        </ul>
        <p>
           We do not sell or rent your personal data to third parties for their
          marketing purposes.
        </p>
  
        {/* Section 4 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          4. Data Security</h2>
        <p>
          We implement reasonable technical and organizational measures to protect
          your personal data, but no method of transmission is 100% secure.
        </p>
  
        {/* Section 5 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          5. Data Retention</h2>
        <p>
          We retain your personal data as long as necessary to provide services
          and comply with legal obligations.
        </p>
  
        {/* Section 6 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          6. Your Rights</h2>
        <p>
          You may access, update, correct, or delete your data. For end-user data,
          you are the controller, and requests must be directed to you.
        </p>
  
        {/* Section 7 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          7. Cookies</h2>
        <p>You can manage cookies through your browser settings.</p>
  
        {/* Section 8 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          8. Links to Third-Party Websites
        </h2>
        <p>This Privacy Policy does not apply to third-party sites.</p>
  
        {/* Section 9 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          9. Changes to This Policy
        </h2>
        <p>
          We may update this Privacy Policy and notify you via website or email.
        </p>
  
        {/* Section 10 */}
        <h2 style={{ fontSize: "22px", marginTop: "25px", fontWeight:"bold" }}>
          10. Contact Us</h2>
        <p>
          <strong>TCL Legal Department</strong>
          <br />
          701, C - wing, 7th Floor, Lotus Corporate Park,
          <br />
          Off Western Express Highway, Goregaon (E),
          <br />
          Mumbai 400063, Maharashtra, India
          <br />
          📧 legal@tubelightcommunications.com
        </p>
      </div>
      </MainContainer>
    );
  }
  
  // return (
  //   <>
  //     {/* <HeroContainer imageUrl={IMAGES.bg1} bgSize="cover"> */}
  //     {/* <ContactHome heading={`Get in Touch!`} rightImg={IMAGES.contact_us} /> */}
  //     <MainContainer>
  //       <ReactMarkdown>{content}</ReactMarkdown>
  //     </MainContainer>
  //     {/* </HeroContainer> */}
  //     {/* <MainContainer>
  //       <Mapgoogle />
  //     </MainContainer> */}
  //   </>
  // );

